import React, { useEffect, useState } from 'react';
import { Badge, Modal, Spinner, Table } from 'react-bootstrap';
import { payrollAPI } from '../../services';
import { toast } from 'react-toastify';
import { format } from 'date-fns';

const formatCurrency = (value) => {
  if (value === undefined || value === null) return '-';
  return new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(Number(value));
};

const formatDateTime = (value) => {
  if (!value) return '-';
  try {
    return format(new Date(value), 'dd/MM/yyyy HH:mm');
  } catch {
    return value;
  }
};

const SOURCE_TYPE_LABELS = {
  TASK_REVIEW: 'Đánh giá công việc',
  MANUAL: 'Thủ công',
  ATTENDANCE: 'Chấm công',
  OTHER: 'Khác',
};

export default function PointsDetailModal({ show, onHide, payrollId }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show && payrollId) {
      fetchPointsDetail();
    } else {
      setData(null);
    }
  }, [show, payrollId]);

  const fetchPointsDetail = async () => {
    try {
      setLoading(true);
      const response = await payrollAPI.getPointsDetail(payrollId);
      setData(response);
    } catch (error) {
      console.error('Cannot fetch points detail', error);
      toast.error(error?.message || 'Không tải được chi tiết điểm');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Chi tiết điểm thưởng/phạt</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading && (
          <div className="text-center py-4">
            <Spinner animation="border" />
          </div>
        )}

        {!loading && !data && <div className="text-muted">Không có dữ liệu</div>}

        {!loading && data && (
          <>
            {data.summary && (
              <div className="mb-4 p-3 bg-light rounded">
                <h6 className="mb-3">Tóm tắt điểm</h6>
                <div className="row">
                  <div className="col-md-4">
                    <div>
                      <strong>Điểm thưởng dùng (80%):</strong> {data.summary.reward_used || 0}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div>
                      <strong>Điểm thưởng tích lũy (20%):</strong> {data.summary.reward_accumulated || 0}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div>
                      <strong>Điểm phạt:</strong> {data.summary.penalty || 0}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {data.points && data.points.length > 0 ? (
              <Table responsive hover>
                <thead>
                  <tr>
                    <th>Ngày</th>
                    <th>Loại</th>
                    <th>Giá trị</th>
                    <th>Nguồn</th>
                    <th>Ghi chú</th>
                    <th>Tích lũy</th>
                  </tr>
                </thead>
                <tbody>
                  {data.points.map((point) => (
                    <tr key={point.id}>
                      <td>{formatDateTime(point.created_at)}</td>
                      <td>
                        <Badge bg={point.type === 'ADD' ? 'success' : 'danger'}>
                          {point.type === 'ADD' ? '+' : '-'}
                        </Badge>
                      </td>
                      <td>
                        <strong>{point.value || 0}</strong>
                      </td>
                      <td>{SOURCE_TYPE_LABELS[point.source_type] || point.source_type || '-'}</td>
                      <td>{point.reason || point.note || '-'}</td>
                      <td>
                        {point.is_accumulated ? (
                          <Badge bg="info">Có</Badge>
                        ) : (
                          <Badge bg="secondary">Không</Badge>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <div className="text-center text-muted py-4">Không có điểm thưởng/phạt</div>
            )}
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary" onClick={onHide}>
          Đóng
        </button>
      </Modal.Footer>
    </Modal>
  );
}

